import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import Wysiwyg from "theme/modules/WysiwygV2";
import classNames from "classnames";

const CategoriesMenu = ({ category, isSubMenuOpen, setIsSubMenuOpen }) => {
  const containerRef = React.useRef(null);

  const updatePosition = React.useCallback(() => {
    const container = containerRef.current;
    if (container) {
      const rect = container.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const parentRect = container.parentElement.getBoundingClientRect();

      let leftPosition = parentRect.left;

      if (rect.right > viewportWidth) {
        leftPosition = parentRect.left - rect.width;
      }

      container.style.left = `${leftPosition}px`;
    }
  }, []);

  React.useEffect(() => {
    // Initial position
    updatePosition();

    // Pour le resize
    window.addEventListener("resize", updatePosition);

    // Pour le scroll du slider
    const menuList = document.querySelector(".menu-main-categories__list");
    if (menuList) {
      menuList.addEventListener("scroll", updatePosition);
    }

    return () => {
      window.removeEventListener("resize", updatePosition);
      if (menuList) {
        menuList.removeEventListener("scroll", updatePosition);
      }
    };
  }, [updatePosition, category]);

  const tabNav = (e) => {
    if (e.keyCode === 40) {
      e.preventDefault();
      const nextElement = e.target.nextElementSibling;
      if (nextElement) {
        nextElement.focus();
      }
    }

    if (e.keyCode === 38) {
      e.preventDefault();
      const previousElement = e.target.previousElementSibling;

      if (previousElement) {
        previousElement.focus();
      } else {
        e.target
          .closest(".menu-main-categories__link-container")
          .querySelector("a")
          .focus();
      }
    }
  };

  return (
    <div
      className={classNames("categories-menu__container", {
        "categories-menu__container--visible": isSubMenuOpen,
      })}
      ref={containerRef}
      onMouseEnter={() => setIsSubMenuOpen(true)}
      onMouseLeave={() => setIsSubMenuOpen(false)}
      onKeyDown={tabNav}
      id={"sub-menu-" + category.id}
      role="tablist"
    >
      <div className="categories-menu">
        {category.children.map((category) => (
          <Link
            to={category.path}
            className="categories-menu__item"
            key={category.id}
            tabIndex={isSubMenuOpen ? 0 : -1}
            role="tab"
          >
            {category.name}
          </Link>
        ))}
        {category.descriptionWysiwyg &&
        category.descriptionWysiwyg.childNodes &&
        category.descriptionWysiwyg.childNodes.length > 0 ? (
          <div className="categories-menu__list">
            <Wysiwyg content={category.descriptionWysiwyg} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CategoriesMenu;
